import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addCompanyReview,
  fetchCompanyReviews,
  updateCompanyReviews,
} from "./CompanyReviewsAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCompanyReviewsAsync = createAsyncThunk(
  "CompanyReviews/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchCompanyReviews();

      const resp = data.response.data;
      // console.log("data's response", data.response.data)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCompanyReviewsAsync = createAsyncThunk(
  "CompanyReviews/update",
  async ({ uuid, data }, { rejectWithValue }) => {
    try {
      const response = await updateCompanyReviews(uuid, data);
     
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// candidate side
export const addCompanyReviewAsync = createAsyncThunk(
  "CompanyReviews/add",
  async (newCompanyReview) => {
    try {
      const data = await addCompanyReview(newCompanyReview);
    
      return data;
    } catch (error) {
      return error
      // return rejectWithValue(error.message);
    }
  }
);

const CompanyReviewsSlice = createSlice({
  name: "CompanyReviews",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyReviewsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyReviewsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchCompanyReviewsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(addCompanyReviewAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(addCompanyReviewAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add CompanyReview";
      })

      .addCase(updateCompanyReviewsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateCompanyReviewsAsync.fulfilled, (state, action) => {
        state.status = "succeeded";

        if (!state.reviews || !Array.isArray(state.reviews)) {
          console.error("state.reviews is not an array:", state.reviews);
          return;
        }

        const index = state.reviews.findIndex(
          (review) => review.uuid === action.payload?.uuid
        );

        if (index !== -1 && action.payload?.status) {
          state.reviews[index] = {
            ...state.reviews[index],
            status: action.payload.status,
          };
        } else {
          console.error("Review not found or invalid payload:", action.payload);
        }
      })

      .addCase(updateCompanyReviewsAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const selectCompanyReview = (state) => state.companyReviews.data;

export default CompanyReviewsSlice.reducer;
